var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-settings-container"},[_c('router-view'),_c('SuccessNotification',[_vm._v(" "+_vm._s(_vm.$t('general.successfulNotification'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }